
<script setup lang="ts">
import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
const $buildingStore = useCalcBuildingStore();
</script>

<template>

<div class="" style="margin-top: 1rem; text-align: left;">
      <div class="blk-win-text">

        <p class="blk-win-paragraph">Сборное здание отгружается непосредственно на строительную площадку заказчика. 
          Доставку по всей России осуществляют надежные специализированные логистические компании.</p>
        <p class="blk-win-paragraph">Срок изготовления и доставки комплекта здания - 4 недели с момента оплаты.</p>
        <p class="blk-win-paragraph">По вопросам расчета стоимости и сроков доставки готовых металлоконструкций обращайтесь к менеджеру компании по телефону {{$buildingStore.telephone}}.</p>
      </div>
    </div>
</template>

<style scoped>
.blk-win-text,
.blk-win-specs {
  flex: 1;
  min-width: 300px;
}
.blk-win-paragraph {
  text-align: start;
color:  #212529;
font-weight: 400;
font-size: 16px;
line-height: 120%;
letter-spacing: 0%;

  margin: 0 0 10px;
}
</style>
